import { AcceptUser } from '@/components';

const InstantMeetingsFoundState = () => {
	return (
		<div className={'instant-container'}>
			<div className={'instant-info-container'}>
				<h1 className={'success-text'}>Hazırsan Öğrenciler Seni Bekliyor</h1>
				<p>Kısa bir süre sonra görüşmeniz başlayacak! Bu süre sarfında öğrencinizi detaylıca inceleyebilir, görüşme öncesi fikir edinebilirsiniz.</p>
			</div>

			<div className={'instant-actions-container'}>
				<AcceptUser />
			</div>
		</div>
	);
};

export default InstantMeetingsFoundState;
